import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Accordion } from "react-bootstrap"
import Branches from "../../../../static/images/whole-child/Branches.png"
import Leaves from "../../../../static/images/whole-child/Leaves.png"
import Roots from "../../../../static/images/whole-child/Roots.png"
import Sunlight from "../../../../static/images/whole-child/Sunlight.png"
import Tree from "../../../../static/images/whole-child/Tree.png"
import Trunk from "../../../../static/images/whole-child/Trunk.png"
import AccordionItem from "./accordion-item"
import "./section-the-whole-child-model-v2.scss"

const data = {
  title: "The Whole Child Model",
  text: "<p>The Whole Child Model is a framework for understanding and supporting children's development. It is based on the idea that children are whole and complete beings, and that their development is a process of growth and change.</p>",
  accordionItems: [
    {
      id: "1",
      title: "Roots",
      subHeading: "Home, Family, Community, School",
      content:
        "<p>A child&apos;s foundation begins with the people and environments that surround them. We partner with parents, caregivers, educators, and communities to build a consistent, supportive circle around every child.</p><p>When families feel supported, children feel safe—and real progress begins.</p>",
    },
    {
      id: "2",
      title: "Trunk",
      subHeading: "Brain & Body Systems",
      content:
        "<p>Healthy development starts from within. Our medical team addresses the biological systems that influence learning, behavior, and mood. By understanding your child&apos;s unique biology, we can personalize treatments that strengthen both body and brain.</p><p>When the body works in harmony, the mind can flourish.</p>",
    },
    {
      id: "3",
      title: "Branches",
      subHeading: "Brain Networks in Action",
      content:
        "<p>These are the networks that power every skill—from focus and movement to connection and communication. We combine evidence-based therapies to strengthen these pathways, helping your child gain confidence and independence step by step.</p><p>Every connection built in the brain unlocks new possibilities.</p>",
    },
    {
      id: "4",
      title: "Leaves",
      subHeading: "Lifelong Learning & Daily Skills",
      content:
        "<p>As your child&apos;s core skills grow, they begin to explore, connect, and give back. We nurture these abilities through play, social interaction, and real-world practice—helping your child develop independence and a sense of purpose.</p><p>Growth means more than milestones—it&apos;s learning to live, love, and belong.</p>",
    },
    {
      id: "5",
      title: "Sunlight",
      subHeading: "Joy and Well-Being",
      content:
        "<p>Joy is the ultimate goal of development—when a child can express themselves freely, form meaningful connections, and engage with the world with curiosity and happiness. Every layer of care we provide is designed to bring your child closer to this feeling.</p><p>When the whole child thrives, joy naturally follows.</p>",
    },
  ],
}

const imagesByIndex = {
  "": Tree,
  1: Roots,
  2: Trunk,
  3: Branches,
  4: Leaves,
  5: Sunlight,
}

const SectionTheWholeChildModelV2 = ({ text, title }) => {
  const [activeIndex, setActiveIndex] = useState("")
  return (
    <section className="section-the-whole-child-model-v2">
      <div className="container-v2">
        <div className="section-the-whole-child-model-v2--left-column">
          <div className="section-the-whole-child-model-v2--header">
            {title && (
              <h2 className="section-the-whole-child-model-v2--title">
                <TextLockupV2>{title}</TextLockupV2>
              </h2>
            )}
            {text?.childrenMarkdownRemark[0]?.html && (
              <div
                className="section-the-whole-child-model-v2--text"
                dangerouslySetInnerHTML={{
                  __html: text.childrenMarkdownRemark[0].html,
                }}
              />
            )}
          </div>
          <div className="section-the-whole-child-model-v2--image-wrapper">
            <img
              alt="Whole Child Model diagram"
              src={imagesByIndex[activeIndex] || imagesByIndex[""]}
            />
          </div>
        </div>

        <div className="section-the-whole-child-model-v2--right-column accordion-items-wrapper">
          <Accordion activeKey={activeIndex} onSelect={setActiveIndex}>
            {data?.accordionItems?.map(item => (
              <AccordionItem
                activeIndex={activeIndex}
                content={item.content}
                heading={item.title}
                icon={item.icon}
                index={item.id}
                isAccordion={true}
                key={item.id}
                subHeading={item.subHeading}
              />
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  )
}

export default SectionTheWholeChildModelV2

SectionTheWholeChildModelV2.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
